import React, { useState } from "react";
import "../css/forgot-password.css";
import { useSelector } from "react-redux";

export default function ForgotPassword() {
  const { Component } = useSelector((state) => state.ForgotPasswordReducer);

  return <>{Component}</>;
}
